import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from '@bibliocommons/base-links';
import { bindAll } from '@bibliocommons/utils-react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import { truncate } from '@bibliocommons/utils-string';

const { composeAuthorClickEvent } = bibEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

export default class AuthorLink extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    const { reciprocalRank } = this.props;
    sendAnalyticsEvents(
      composeAuthorClickEvent({
        containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM,
        reciprocalRank
      })
    );
  }

  constructLink(authorName, searchPath) {
    const { linkTag: LinkTag, renderAsLink, truncateCount } = this.props;
    const truncatedAuthorName =
      truncateCount && authorName ? truncate(authorName, { desiredLength: truncateCount }) : authorName;

    if (!truncatedAuthorName) return null;

    const content = (
      <span>
        <span aria-hidden>{truncatedAuthorName}</span>
        <ScreenReaderMessage>{authorName}</ScreenReaderMessage>
      </span>
    );

    if (!renderAsLink) {
      return content;
    }

    return (
      <LinkTag
        dataKey="author-link"
        handleClick={this.handleClick}
        href={searchPath}
        target={this.props.target}
        rel="noopener noreferrer"
      >
        {content}
      </LinkTag>
    );
  }

  renderAuthorLinks(author) {
    const searchType = author.get('searchType') || 'author';

    const authorName = author.get('fullName') || author.get('name');
    const searchQuery = author.get('searchQuery') || authorName;
    const searchPath = `/v2/search?query=${encodeURIComponent(searchQuery)}&searchType=${searchType}`;

    const otherScriptAuthorName = author.get('otherScriptFullName');
    const otherScriptSearchQuery = author.get('otherScriptSearchQuery') || author.get('otherScriptFullName');
    const otherScriptSearchPath = `/v2/search?query=${otherScriptSearchQuery}&searchType=${searchType}`;

    return (
      <span>
        {this.constructLink(otherScriptAuthorName, otherScriptSearchPath)}
        {authorName && otherScriptAuthorName && ' • '}
        {this.constructLink(authorName, searchPath)}
      </span>
    );
  }

  renderAuthors() {
    const { authors } = this.props;

    return authors.map((author, i) => {
      return (
        <span key={author.get('id')}>
          {this.renderAuthorLinks(author)}
          {i < authors.size - 1 && ' • '}
        </span>
      );
    });
  }

  render() {
    return <div className="cp-author-link">{this.renderAuthors()}</div>;
  }
}

AuthorLink.propTypes = {
  authors: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  target: PropTypes.string,
  reciprocalRank: PropTypes.number,
  linkTag: PropTypes.elementType,
  renderAsLink: PropTypes.bool,
  truncateCount: PropTypes.number
};

AuthorLink.defaultProps = {
  target: '_parent',
  linkTag: Link,
  renderAsLink: true
};
